import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { UserModel } from '../models';

@Injectable()
export class ServiceHelper {
    /**
     * On next request, set Cache-Control: no-cache
     * Should toggle back after one request
     */
    applyNoCacheOnNextRequest: boolean = false;
    /**
     * For exactly one next request, set Cache-Control: no-cache to cachebust
     */
    NoCacheNextRequest() {
        this.applyNoCacheOnNextRequest = true;
    }
    GetBearerToken(): string {
        var str = localStorage.getItem('user');
        var user: UserModel = JSON.parse(str);
        return user?.Token || 'test';
    }
    GetHeaders(): any {
        var str = localStorage.getItem('user');
        var user: UserModel = JSON.parse(str);

        var headers = { 'Content-Type': 'application/json' };
        if (this.applyNoCacheOnNextRequest) {
            this.applyNoCacheOnNextRequest = false;
            headers['Cache-Control'] = 'no-cache';
        }

        if (user) {
            headers['Authorization'] = 'Bearer ' + user.Token;
        }
        return headers;
    }
    GetUploadHeaders(): any {
        var str = localStorage.getItem('user');
        var user: UserModel = JSON.parse(str);

        if (user) {
            return new HttpHeaders({ 'Accept': 'application/json', 'Authorization': 'Bearer ' + user.Token });
        } else {
            return new HttpHeaders({ 'Accept': 'application/json' });
        }
    }
    GetTempHeaders(): any {
        var str = localStorage.getItem('temp_user');
        var user: UserModel = JSON.parse(str);

        if (user) {
            return new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + user.Token });
        } else {
            return new HttpHeaders({ 'Content-Type': 'application/json' });
        }
    }
    handleError(error: Response) {
        console.error("Error: HTTP status " + error.status);
        return Observable.throw(error || 'Server error: UserService');
    }

}
